/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @name: pageExportConfig
 * @description: 导出方案（页面导出配置）API 层，对接 /api/go-lcc/pageExportConfig 接口
 *               - getByPageCode 仅按 pageCode 查询方案列表
 *               - save/update 的业务参数为 pageCode + configName（方案名称）+ columns（字段配置数组）
 *               - globalApply（全局应用）后端接口暂未声明该字段，先按此字段名传递，等待后端配合支持
 */
import {QueryCommand} from 'xmgoing-server';

/** 方案字段配置项，结构与 getComponentByPageCode 返回项一致 */
export interface PageExportConfigColumn {
  code: string;
  name: string;
  inTemplate: boolean;
  componentType?: string;
  config?: string;
  source?: string;
  sourceName?: string;
  [k: string]: any;
}

/** 页面导出配置（导出方案）数据模型 */
export interface PageExportConfigDTO {
  id?: string;
  pageCode?: string;
  /** 方案名称 */
  configName?: string;
  /** 字段配置数组 */
  columns?: PageExportConfigColumn[];
  /** 是否全局应用：后端接口暂未声明该字段，先按此字段名传递 */
  globalApply?: boolean;
  [k: string]: any;
}

/**
 * 查询页面导出配置（方案）列表
 * GET /api/go-lcc/pageExportConfig/getByPageCode
 */
export function getPageExportConfigByPageCode({pageCode, backFun, errorFun}: any) {
  const queryCommand = new QueryCommand({url: '/api/go-lcc/pageExportConfig/getByPageCode', method: 'GET'});
  queryCommand.executeQueryPromise({params: {pageCode}}).then((res: any) => {
    backFun && backFun(res);
  }).catch((e: any) => {
    errorFun && errorFun(e);
  });
}

/**
 * 新增导出方案
 * POST /api/go-lcc/pageExportConfig/save
 */
export function savePageExportConfig(data: PageExportConfigDTO, backFun?: (res?: any) => void, errorFun?: (e?: any) => void) {
  const queryCommand = new QueryCommand({url: '/api/go-lcc/pageExportConfig/save', method: 'POST'});
  queryCommand.executeQueryPromise({params: {...data}}).then((res: any) => {
    backFun && backFun(res);
  }).catch((e: any) => {
    errorFun && errorFun(e);
  });
}

/**
 * 修改导出方案
 * POST /api/go-lcc/pageExportConfig/update
 */
export function updatePageExportConfig(data: PageExportConfigDTO, backFun?: (res?: any) => void, errorFun?: (e?: any) => void) {
  const queryCommand = new QueryCommand({url: '/api/go-lcc/pageExportConfig/update', method: 'POST'});
  queryCommand.executeQueryPromise({params: {...data}}).then((res: any) => {
    backFun && backFun(res);
  }).catch((e: any) => {
    errorFun && errorFun(e);
  });
}

/**
 * 删除导出方案
 * POST /api/go-lcc/pageExportConfig/remove
 * @param ids 要删除的方案 id
 */
export function removePageExportConfig(ids: string, backFun?: (res?: any) => void, errorFun?: (e?: any) => void) {
  const queryCommand = new QueryCommand({url: '/api/go-lcc/pageExportConfig/remove', method: 'POST'});
  queryCommand.executeQueryPromise({params: {ids}}).then((res: any) => {
    backFun && backFun(res);
  }).catch((e: any) => {
    errorFun && errorFun(e);
  });
}
